import Box from '@mui/material/Box'
import React, { useMemo } from 'react'

import UserCardMapImage from '../_common/UserCardMapImage'

const JudgeVotedMaps = ({ contestRelation, ownerId, mapHeight, isJudge, isPublishedRound, isWithPopper = true }) => {
  const judgeVotedMapsArr = useMemo(() => {
    const userVotedMaps = contestRelation?.contest_judges?.[ownerId]?.judge_vote_result_by_contest
    if (!userVotedMaps) return []
    return userVotedMaps.map((map) => contestRelation.maps[map.map_id])
  }, [contestRelation, ownerId])

  return (
    (isJudge || isPublishedRound) &&
    judgeVotedMapsArr.length > 0 && (
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: '5px',
          padding: '10px',
          justifyContent: 'center',
        }}
      >
        {judgeVotedMapsArr.map((mapCard, index) => (
          <Box key={mapCard.id}>
            <UserCardMapImage
              mapCard={mapCard}
              index={index}
              length={judgeVotedMapsArr.length}
              mapHeight={mapHeight}
              isWithPopper={isWithPopper}
            />
          </Box>
        ))}
      </Box>
    )
  )
}

export default JudgeVotedMaps
